module.exports = __webpack_public_path__ + "img/screen5.3b9158d4.png";